// extracted by mini-css-extract-plugin
export default {"wrap":"ToggleMenu_wrap__Fo1kE","iconArea":"ToggleMenu_iconArea__nIZsV"};